import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import config from '../../config/config'
import { getToken, checkJapanese } from '../../lib'
import moment from 'moment'
import Paper from 'material-ui/Paper'
import PageView from 'material-ui/svg-icons/action/pageview'
import { FormattedMessage } from 'react-intl'
import RaisedButton from 'material-ui/RaisedButton'
import TextField from 'material-ui/TextField'
import Toggle from 'material-ui/Toggle'
import { ALertHeaderText } from './styles'
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table'
import Visibility from 'material-ui/svg-icons/action/visibility'
import VisibilityOff from 'material-ui/svg-icons/action/visibility-off'
import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card';

const toggleStyle = {
  thumbSwitched: {
    backgroundColor: '#88E0A8'
  },
  thumbOff: {
    backgroundColor: '#46CE90'
  }
}


class Domain extends Component {
  constructor(props) {
    super(props)
    this.state = {
      domains: null,
      domainName: `/fvdomain`,
      maintenanceMode: false,
      maintenanceMessage: '',
      typeMaintenanceMode: '',
      maintenancePassword: '',
      maintenanceError: null,
      showHideDomains: false,
    }
  }

  saveMaintenanceConfig = () => {
    if(config.MAINTENANCE_PASSWORD == this.state.maintenancePassword && config.MAINTENANCE_TEXT == this.state.typeMaintenanceMode) {
      const payload = {
        maintenance_mode: this.state.maintenanceMode,
        maintenance_message: this.state.maintenanceMessage
      }

      return fetch(`${config.URI}/api/v1/config`, {
        method: 'POST',
        headers: {
          'Authenticity-Token': getToken(),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      }).then((temp) => temp.json())
        .then(res => {
          if (res.status && res.status === 'success') {
            let warning = checkJapanese() ? '保存された設定' : 'Settings saved.';
            alert(warning)
          }
        })
        .catch((err) => {
          let warning = checkJapanese() ? 'サーバーとの接続にエラーが発生しました。' : 'There was an error connecting to the server.';
          alert(warning)
        })
    } else {
      this.setState({maintenanceError: true});
    }
  }

  showHideDomains = (reload = false) => {
      const queryParams = (!this.state.showHideDomains && !reload) || (this.state.showHideDomains && reload) ? 'true' : 'false'; 
      const APIurl = `${config.URI}/api/v1/fvdomains?active_domain=${queryParams}`;
      this.Filter(APIurl)
      this.setState({showHideDomains: reload ? this.state.showHideDomains : !this.state.showHideDomains});
  }

  Filter = (APIurl) => {
    const token = getToken()
    return fetch(`${APIurl}`, {
      method: 'GET',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      }
    })
      .then((temp) => temp.json())
      .then(res => {
        if (res.status && res.status === 'success') {
          if (res.data === 'use admin') {
            let warning = checkJapanese() ? '管理者アカウントを使ってください。' : 'Use an administrator account.';
            alert(warning)
            window.location = '/'
          } else {
            this.setState({ domains: res.data.domains, maintenanceMode: res.data.maintenanceMode, maintenanceMessage: res.data.maintenanceMessage })
          }
        }
      })
      .catch((error) => {
        let warning = checkJapanese() ? 'サーバーとの接続にエラーが発生しました。' : 'There was an error connecting to the server.';
        alert(warning)
        
      })
  }

  handleChangeMessage = (e) => {
    this.setState({ maintenanceMessage: e.target.value})
  }

  handleChange = (e) => {
    this.setState({ typeMaintenanceMode: e.target.value})
  }

  maintenancePassword = (e) => {
    this.setState({ maintenancePassword: e.target.value})
  }

  handleToggle = (e, isToggled) => this.setState({maintenanceMode: isToggled})

  componentDidMount() {
    this.showHideDomains(false)
  }

  hideUnhideDomain(domainId) {
    const apiUrl = `${config.URI}/api/v1/fvdomains/${domainId}/hide_domain` ;
    const payload = {
      domainId: domainId,
      requestType: this.state.showHideDomains,
    }

    return fetch( apiUrl, {
      method: 'post',
      headers: {
        'Authenticity-Token': getToken(),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then((temp) => temp.json())
      .then(res => {
        if (res.data && res.data.domain) {
          if(res.data.domain.is_hidden){
            var  warning = checkJapanese() ? `${res.data.domain.name} を非表示にしました` : `${res.data.domain.name} has been successfully hidded.`;
          }else{
            var warning = checkJapanese() ? `${res.data.domain.name} を再表示しました` : `${res.data.domain.name} has been successfully unhidden.`;
          }
          confirm(warning);
          this.showHideDomains(true);
        } 
      }).catch(e => {
        console.error("---->>>error",e)
      })
  }

  render() {
    let domainRoute = this.state.domainName
    return (
      <div className="pl3 h-100" style={{ color: '#6B7C93' }}>
        <Card style={{maxWidth: '720px',  marginBottom: '20px', marginTop: '20px'}}>
          <CardText style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '0'}}>
            <ALertHeaderText>
              <FormattedMessage id='maintenance.settings'/>
            </ALertHeaderText>
            <Toggle
              label={(this.state.maintenanceMode) 
                ? (<FormattedMessage id='seminar.on'/>) 
                : <FormattedMessage id='seminar.off'/>
              }
              toggled={this.state.maintenanceMode}
              onToggle={this.handleToggle}
              labelPosition='right'
              thumbSwitchedStyle={toggleStyle.thumbOff}
              trackSwitchedStyle={toggleStyle.thumbSwitched}
              style={{ width: 'auto' }}
              labelStyle={{
                fontSize: '14px',
                lineHeight: '20px',
                color: 'rgba(107, 124, 147, 1)',
                opacity: 1
              }}
              ref='maintenanceMode'
            />
          </CardText>
          <CardText style={{ paddingTop: '8px' }}>
            <TextField
              hintText={<FormattedMessage id='maintenance.messagePlaceholder' />}
              onChange={this.handleChangeMessage}
              name='maintenanceMessage'
              value={this.state.maintenanceMessage}
              fullWidth
            />
            <TextField
              hintText={<FormattedMessage id='maintenance.typeMaintenanceModeHint' values={{string: config.MAINTENANCE_TEXT}} />}
              onChange={this.handleChange}
              name='typeMaintenanceMode'
              fullWidth
            />

            <TextField
              hintText={<FormattedMessage id='maintenance.maintenancePassword' />}
              onChange={this.maintenancePassword}
              name='maintenancePassword'
              fullWidth
            />

            <div style={{ marginTop: '10px' }}>
              <RaisedButton
                onTouchTap={this.saveMaintenanceConfig}
                backgroundColor='#FCCE42'
                labelStyle={{ color: '#8B7124' }}
                label={<FormattedMessage id='seminar.save' />}
                style={{ height: 42 }} 
              />
              <RaisedButton
                onTouchTap={() => {this.showHideDomains(false)}}
                backgroundColor= {this.state.showHideDomains ? '#FF5733' : '#009933'}
                labelStyle={{ color: '#ffffff' }}
                label={this.state.showHideDomains ? <FormattedMessage id='CreateDomainLabel.hiddenDomain' /> : <FormattedMessage id='CreateDomainLabel.activeDomains' />}
                style={{ height: 42, float: "right" }} 
              />
            </div>
          </CardText>
        </Card>
        <div>
          <Paper style={{ borderRight: '2px solid #e3e3e3', height: '85vh', padding: '10px' }}>
            <Table selectable={false} selectedColor="black" height={'70vh'}>
              <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                <TableRow>
                  <TableHeaderColumn><FormattedMessage id='CreateDomainLabel.name' /></TableHeaderColumn>
                  <TableHeaderColumn><FormattedMessage id='CreateDomainLabel.contractStatus' /></TableHeaderColumn>
                  <TableHeaderColumn><FormattedMessage id='CreateDomainLabel.domainStatus' /></TableHeaderColumn>
                  <TableHeaderColumn><FormattedMessage id='CreateDomainLabel.expirationDate' /></TableHeaderColumn>
                  <TableHeaderColumn style={{ whiteSpace: 'normal' }}><FormattedMessage
                    id='CreateDomainLabel.maxAccountNumber' />
                  </TableHeaderColumn>
                  <TableHeaderColumn style={{ whiteSpace: 'normal' }}><FormattedMessage
                    id='CreateDomainLabel.fvDomainsName' />
                  </TableHeaderColumn>
                  <TableHeaderColumn><FormattedMessage id='CreateDomainLabel.FVDomainType'/></TableHeaderColumn>
                  <TableHeaderColumn><FormattedMessage id='CreateDomainLabel.creditPayment'/></TableHeaderColumn>
                  <TableHeaderColumn><FormattedMessage id='CreateDomainLabel.action'/></TableHeaderColumn>
                  <TableHeaderColumn>
                    { this.state.showHideDomains ? 
                      <FormattedMessage id='CreateDomainLabel.hide'/>
                    :
                      <FormattedMessage id='CreateDomainLabel.unhide'/>
                    } 
                  </TableHeaderColumn>
                </TableRow>
              </TableHeader>
              <TableBody deselectOnClickaway={false} displayRowCheckbox={false}>
                {this.state.domains && this.state.domains.map((val, index) => (!this.state.showHideDomains ? val.is_hidden : !val.is_hidden) && (
                  <TableRow key={index} selected={false} style={{ backgroundColor: '#f2f3f6' }}>
                    <TableRowColumn style={{ fontSize: 14, color: '#6B7C93' }}>{val.name}</TableRowColumn>
                    <TableRowColumn style={{
                      fontSize: 14,
                      color: '#6B7C93'
                    }}>{(val.trial) ? 'トライアル(Trial)' : '本契約(Payed Users)'} </TableRowColumn>
                    <TableRowColumn style={{ fontSize: 14, color: '#6B7C93' }}>
                      {val.status === 'expire' ? <null>{val.expire_flag ? '無効(invalid)' : '有効(valid)'} </null> : null}
                      {val.status === 'valid' && '有効(valid)'}
                      {val.status === 'invalid' && '無効(invalid)'}</TableRowColumn>
                    <TableRowColumn style={{
                      fontSize: 14,
                      color: '#6B7C93'
                    }}>{(val.status === 'expire') ? moment(val.expire).format('YYYY-MM-DD') : ''}</TableRowColumn>
                    <TableRowColumn style={{ fontSize: 14, color: '#6B7C93' }}>{val.max_account_num}</TableRowColumn>
                    <TableRowColumn style={{ fontSize: 14, color: '#6B7C93' }}>
                      {val.fv_domains_name}
                    </TableRowColumn>
                    <TableRowColumn style={{fontSize: 14, color: '#6B7C93'}}>
                      {val.fvdomain_type}
                    </TableRowColumn>
                    <TableRowColumn style={{fontSize: 14, color: '#6B7C93'}}>
                      {val.credit_payment}
                    </TableRowColumn>
                    <TableRowColumn style={{fontSize: 14, color: '#6B7C93'}}><Link to={`${domainRoute}/${val.id}`}>{
                      <PageView color={'#000000de'}/>}</Link></TableRowColumn>
                    <TableRowColumn style={{fontSize: 14, color: '#6B7C93'}}>
                      {this.state.showHideDomains ? <VisibilityOff color={'#000000de'} onClick={() => this.hideUnhideDomain(val.id)} /> : <Visibility color={'#000000de'} onClick={() => this.hideUnhideDomain(val.id)} />}
                    </TableRowColumn>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </div>
      </div>
    )
  }
}

export default Domain


// WEBPACK FOOTER //
// src/routes/Domain/index.js